<template>
	<div
		style="color: var(--theme-text-color)"
		class="flex items-center space-x-5 justify-end navbar-topbar">
		<div v-if="notifications.length" class="flex items-center">
			<b-dropdown right no-caret variant="link" toggle-class="p-0 d-flex align-items-center" ref="notifDropdown">
				<template #button-content>
					<span :style="'color: ' + notifVariantColor(notifications[0].data.type) + '; position: relative; display: inline-block; padding: 8px 14px 2px 2px; overflow: visible;'">
						<i class="fas fa-bell"></i>
						<span :style="'position: absolute; top: 0px; right: 6px; background: ' + notifVariantColor(notifications[0].data.type) + '; color: white; border-radius: 50%; min-width: 16px; height: 16px; font-size: 10px; display: inline-flex; align-items: center; justify-content: center; font-weight: bold; padding: 0 3px;'">{{ notifications.length }}</span>
					</span>
					<span style="font-size: 13px; max-width: 220px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; vertical-align: middle;">{{ notifications[0].title }}</span>
				</template>
				<div style="min-width: 320px; max-height: 460px; overflow-y: auto;">
					<div class="px-3 py-2 border-bottom" style="font-weight: 600; font-size: 12px; color: #888; text-transform: uppercase; letter-spacing: 0.5px;">
						<i class="fas fa-bell mr-1"></i> Notifications
					</div>
					<div
						v-for="notification in notifications"
						:key="notification.uid"
						class="ticket-notif-item"
					>
						<div style="flex: 1; min-width: 0;">
							<b-badge :variant="notification.data.type">{{ notification.title }}</b-badge>
							<div style="font-size: 12px; color: #666; margin-top: 3px; white-space: normal;">{{ notification.data.text }}</div>
						</div>
					</div>
				</div>
			</b-dropdown>
		</div>
		<div v-if="false && !back">
			<b-alert 
				title="Déconnexion du serveur" 
				style="margin-top: 10px; margin-bottom: -50px" 
				variant="danger" show><b>Serveur déconnecté</b>
			</b-alert>	
		</div>
		<div v-if="unseen_messages" class="flex items-center">
			<b-button @click="open_message" variant="link" style="color: red; padding: 0; display: inline-flex; align-items: center;">
				<i class="fa fa-envelope"></i>&nbsp;{{unseen_messages}}
			</b-button>
		</div>
		<div v-if="personalNotifications.length" class="flex items-center">
			<b-dropdown right no-caret variant="link" toggle-class="p-0 d-flex align-items-center" ref="personalNotifDropdown">
				<template #button-content>
					<span :style="'color: ' + notifVariantColor(personalNotifications[0].data.type) + '; position: relative; display: inline-block; padding: 8px 14px 2px 2px; overflow: visible;'">
						<i class="fas fa-comment-dots"></i>
						<span :style="'position: absolute; top: 0px; right: 6px; background: ' + notifVariantColor(personalNotifications[0].data.type) + '; color: white; border-radius: 50%; min-width: 16px; height: 16px; font-size: 10px; display: inline-flex; align-items: center; justify-content: center; font-weight: bold; padding: 0 3px;'">{{ personalNotifications.length }}</span>
					</span>
				</template>
				<div style="min-width: 320px; max-height: 460px; overflow-y: auto;">
					<div class="px-3 py-2 border-bottom" style="font-weight: 600; font-size: 12px; color: #888; text-transform: uppercase; letter-spacing: 0.5px;">
						<i class="fas fa-comment-dots mr-1"></i> Notifications personnelles
					</div>
					<div
						v-for="notification in personalNotifications"
						:key="notification.uid"
						class="ticket-notif-item"
					>
						<div class="d-flex align-items-start justify-content-between">
							<div style="flex: 1; min-width: 0; padding-right: 6px;">
								<b-badge :variant="notification.data.type">{{ notification.title }}</b-badge>
								<div style="font-size: 12px; color: #666; margin-top: 3px; white-space: normal;">{{ notification.data.text }}</div>
							</div>
							<button
								class="btn btn-link btn-sm p-0 ml-1"
								style="color: #ccc; line-height: 1; flex-shrink: 0;"
								@click.stop="dismissPersonalNotification(notification.uid)"
								title="Ignorer"
							>
								<i class="fas fa-times"></i>
							</button>
						</div>
					</div>
				</div>
			</b-dropdown>
		</div>
		<div v-if="ticketNotifs.length" class="flex items-center">
			<b-dropdown right no-caret variant="link" toggle-class="p-0" ref="ticketDropdown">
				<template #button-content>
					<span style="color: #e67e22; position: relative; display: inline-block; padding: 8px 10px 2px 2px; overflow: visible;">
						<i class="fas fa-ticket-alt"></i>
						<span style="position: absolute; top: 0px; right: -2px; background: #e67e22; color: white; border-radius: 50%; min-width: 16px; height: 16px; font-size: 10px; display: inline-flex; align-items: center; justify-content: center; font-weight: bold; padding: 0 3px;">{{ ticketNotifs.length }}</span>
					</span>
				</template>
				<div style="min-width: 330px; max-height: 460px; overflow-y: auto;">
					<div class="px-3 py-2 border-bottom" style="font-weight: 600; font-size: 12px; color: #888; text-transform: uppercase; letter-spacing: 0.5px;">
						<i class="fas fa-ticket-alt mr-1"></i> Tickets mis à jour
					</div>
					<div
						v-for="notif in ticketNotifs"
						:key="notif.ticket_id"
						class="ticket-notif-item"
						@click="openTicketNotif(notif)"
					>
						<div class="d-flex align-items-start justify-content-between">
							<div style="flex: 1; min-width: 0; padding-right: 6px;">
								<div>
									<b-badge :variant="getNotifVariant(notif.type)" style="font-size: 10px;">{{ getNotifLabel(notif.type) }}</b-badge>
									<span v-if="notif.count > 1" style="font-size: 10px; color: #aaa; margin-left: 4px;">(+{{ notif.count - 1 }})</span>
								</div>
								<div style="font-weight: 500; font-size: 13px; margin-top: 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
									<span style="color: #aaa; font-size: 12px;">#{{ notif.ticket_id }}</span> {{ notif.ticket_titre }}
								</div>
								<div style="font-size: 11px; color: #bbb; margin-top: 2px;">{{ formatNotifTime(notif.time) }}</div>
							</div>
							<button
								class="btn btn-link btn-sm p-0 ml-1"
								style="color: #ccc; line-height: 1; flex-shrink: 0;"
								@click.stop="dismissTicketNotif(notif.ticket_id)"
								title="Ignorer"
							>
								<i class="fas fa-times"></i>
							</button>
						</div>
					</div>
					<div
						v-if="ticketNotifs.length > 1"
						class="px-3 py-2 text-center border-top"
						style="cursor: pointer; font-size: 12px; color: #aaa;"
						@click="clearAllTicketNotifs"
					>
						<i class="fas fa-check-double mr-1"></i> Tout effacer
					</div>
				</div>
			</b-dropdown>
		</div>
		<div v-if="group">
			<span v-for="(gr, key) in groups" :key="gr.value">
				<span v-if="key != 0"> - </span>
				<b-button @click="change_group(gr.value)" :style="'padding:0px;font-weight:' + ((group == gr.value) ? 'bold' : 'normal')" variant="link">{{gr.text}}</b-button>
			</span>
		</div>
        <div v-if="env" v-b-tooltip.hover :title="env" class="flex items-center navbar-env">
            {{ env }}
        </div>
		<router-link :to="{ name: 'profile' }" style="color: black" class="flex items-center">
            <i class="fa fa-user"></i>
		</router-link>
		<button
			@click="() => $router.push('/logout')"
			class="text-inherit bg-transparent border-none hover:opacity-75 flex items-center">
			<i class="fa fa-sign-out-alt"></i>
		</button>
	</div>
</template>

<script>
	import { v4 as uuidv4 } from 'uuid';
	import store from "../store";
	import users from "../services/users.js";
	import client_services from "../services/client.js";
    import messages_services from "../services/messages.js";
	import notifications_services from "../services/notifications.js";

	export default {
		name: "saas-navbar",
		data() {
			return {
				env: "",
				notifications: [],
				personalNotifications: [],
				user_groups: [],
				group: "",
				groups: [],
				obj_groups: {},
				user: {}
			};
		},
        computed: {
            isAdmin: function() {
                return store.getters.isUserAdmin;
            },
            adminViewToggled: function() {
                return store.getters.getToggleAdminView;
            },
			unseen_messages() {
				return this.$store.getters.getUnseenMessages
			},
			ticketNotifs() {
				return this.$store.getters.getTicketNotifs
			},
			back() {
				return this.$store.getters.getBack
			}
        },
		methods: {
			open_message() {
				let resolvedRoute = this.$router.resolve({
					name: "messages",
				});
				window.open(resolvedRoute.href, '_blank');
			},
			openTicketNotif(notif) {
				this._deleteTicketNotifUids(notif);
				this.$store.commit('removeTicketNotif', notif.ticket_id);
				this.$router.push({ name: 'TicketDetail', params: { id: notif.ticket_id } }).catch(() => {});
			},
			dismissTicketNotif(ticket_id) {
				const notif = this.ticketNotifs.find(n => n.ticket_id === ticket_id);
				if (notif) this._deleteTicketNotifUids(notif);
				this.$store.commit('removeTicketNotif', ticket_id);
			},
			clearAllTicketNotifs() {
				this.ticketNotifs.forEach(notif => this._deleteTicketNotifUids(notif));
				this.$store.commit('clearTicketNotifs');
			},
			// Un ticket peut avoir accumulé plusieurs notif_uid (un par événement :
			// création, message, mise à jour...) ; il faut tous les supprimer en
			// base sinon les plus anciens réapparaissent comme orphelins au reload.
			_deleteTicketNotifUids(notif) {
				const uids = new Set([...(notif.notif_uids || []), notif.notif_uid].filter(Boolean));
				uids.forEach(uid => notifications_services.delete(uid).catch(() => {}));
			},
			notifVariantColor(type) {
				const colors = {
					primary:   '#007bff',
					secondary: '#6c757d',
					success:   '#28a745',
					danger:    '#dc3545',
					warning:   '#ffc107',
					info:      '#17a2b8',
					light:     '#f8f9fa',
					dark:      '#343a40'
				};
				return colors[type] || colors.primary;
			},
			getNotifLabel(type) {
				const labels = {
					ticket_create:         'Nouveau ticket',
					ticket_message:        'Nouveau message',
					ticket_message_update: 'Message modifié',
					ticket_update:         'Mis à jour',
					ticket_assign:         'Assigné'
				};
				return labels[type] || 'Ticket';
			},
			getNotifVariant(type) {
				const variants = {
					ticket_create:         'success',
					ticket_message:        'primary',
					ticket_message_update: 'secondary',
					ticket_update:         'warning',
					ticket_assign:         'info'
				};
				return variants[type] || 'secondary';
			},
			formatNotifTime(time) {
				if (!time) return '';
				return this.moment(time).fromNow();
			},
            toggleAdminView(toggle) {
                store.commit("toggleAdminView", toggle);
			},
			async change_group(group)
			{
				if (group)
					this.group = group;
				console.log(this.group)
				if (!this.user.env) 
					this.user.env = null;
				var user = await users.updateUserSelf(this.user, this.group);
				this.$router.go();
			},
			notif(data)
			{
				if (data.event)
				{
					this.notif_user(data);
				}
				else
				{
					var self = this;
					for (var i = 0; i < self.notifications.length; i++)
					{
						if (self.notifications[i].uid == data.uid)
						{
							self.notifications.splice(i, 1);
							i--;
						}
					}
					if (data.active)
						self.notifications.push(data);
				}
			},
			notif_personal(data)
			{
				var self = this;
				for (var i = 0; i < self.personalNotifications.length; i++)
				{
					if (self.personalNotifications[i].uid == data.uid)
					{
						self.personalNotifications.splice(i, 1);
						i--;
					}
				}
				if (data.active)
					self.personalNotifications.push(data);
			},
			async dismissPersonalNotification(uid)
			{
				var self = this;
				var notif = self.personalNotifications.find(n => n.uid == uid);
				if (!notif || !notif.ephemeral)
					await notifications_services.delete(uid).catch(() => {});
				for (var i = 0; i < self.personalNotifications.length; i++)
				{
					if (self.personalNotifications[i].uid == uid)
					{
						self.personalNotifications.splice(i, 1);
						i--;
					}
				}
			},
			async notif_user(data, filterSender = true)
			{
				if (data.type == "message")
				{
					this.$store.commit("setMessage", data.message_uid);
					var unseen_messages = await messages_services.getUnseenNb();
					this.$store.commit("setUnseenMessages", unseen_messages);
				}
			else if (data.type === 'ticket_create' || data.type === 'ticket_message' || data.type === 'ticket_message_update' || data.type === 'ticket_update' || data.type === 'ticket_assign')
				{
					// Sur les canaux broadcast (smartmydata, client_uid…), ne pas notifier l'expéditeur
					// Sur le canal personnel (user.uid), toujours notifier (l'utilisateur est la cible désignée)
					if (filterSender && data.sender_uid && data.sender_uid === store.state.user.uid) return;

					this.$store.commit('addOrBubbleTicketNotif', {
						ticket_id:    data.ticket_id,
						ticket_titre: data.ticket_titre || `Ticket #${data.ticket_id}`,
						type:         data.type,
						text:         data.text,
						time:         new Date().toISOString(),
						notif_uid:    data.notif_uid || null
					});
				}
				else if (data.data && data.uid !== undefined)
				{
					// Notification "entité" (créée via l'écran Notifications) envoyée directement sur le canal
					// personnel de l'utilisateur (uid) : on l'affiche dans sa propre cloche, distincte des tickets.
					this.notif_personal(data);
				}
				else if (data.type === "notifications")
				{
					// Notification envoyée par l'étape "Notifications" d'un scénario (worker wk-user) : événement
					// éphémère (pas persisté en base), affiché dans la cloche personnelle puis simplement retiré localement.
					this.notif_personal({
						uid: uuidv4(),
						title: data.title || "Notification",
						data: { type: "info", text: data.text || "" },
						active: true,
						ephemeral: true
					});
				}
				else if (data.type)
				{
					this.$store.commit("setEvent", data);
					await this.$nextTick()
					this.$store.commit("setEvent", "");
				}
			}
		},
		mounted: async function () {
			var self = this;

			let response = await users.getSelf(true);
			let user = response.user;
			this.user = user;

			store.commit("setUser",  user);

			if (!user.details) user.details = {};

			if (!user.env) user.env = "";

			let client = response.client;

			store.commit("setClient", client);

			if (user.groups && user.groups.indexOf("|") > 0) 
			{
				this.user_groups = user.groups.split("|");
				this.group = this.user_groups[0];

				var groups = await client_services.getClientGroups();

				this.obj_groups = {};
				for (var i = 0; i < groups.length; i++) 
				{
					if (this.user_groups.includes(groups[i].uid))
					{
						this.obj_groups[groups[i].uid] = groups[i];
						this.groups.push({
							value: groups[i].uid,
							text: groups[i].name,
						});
					}
				}

			}

			var id = this.$socket.id;

			this.sockets.subscribe(user.client_uid, (data) => {
				self.notif(data);
			});

			this.sockets.subscribe(window.location.host, (data) => {
				self.notif(data);
			});

			this.sockets.subscribe('delete', (data) => {
				for (var i = 0; i < self.notifications.length; i++)
				{
					if (self.notifications[i].uid == data)
					{
						self.notifications.splice(i, 1);
						i--;
					}
				}
				for (var i = 0; i < self.personalNotifications.length; i++)
				{
					if (self.personalNotifications[i].uid == data)
					{
						self.personalNotifications.splice(i, 1);
						i--;
					}
				}
				// Un ticket peut être associé à plusieurs notif_uid accumulés
				// (voir addOrBubbleTicketNotif / notif_uids) : si l'uid supprimé
				// correspond à l'UN d'entre eux (peu importe le compte qui a fait
				// la suppression), on retire aussi la bulle ticket correspondante
				// en temps réel, sinon elle reste affichée jusqu'au prochain reload.
				const ticketNotif = self.$store.getters.getTicketNotifs.find(n =>
					n.notif_uid === data || (n.notif_uids || []).includes(data)
				);
				if (ticketNotif) {
					console.log('[ticket-notif][front] socket delete received for', data, '-> removing ticket_id', ticketNotif.ticket_id);
					self.$store.commit('removeTicketNotif', ticketNotif.ticket_id);
				}
			});

			this.sockets.subscribe(user.uid, (data) => {
				self.notif_user(data, false);
			});

			// Les tickets (assignation, suivi, notifications) sont gérés sous
			// l'identité "principale" du groupe Correspondances Tâches (voir
			// tacheCtrl.resolveCanonicalUserUid) : si ce compte est un compte
			// secondaire (ex: jeremie_2), il doit aussi écouter le canal du
			// compte principal pour recevoir les notifications de tickets.
			if (user.ticket_notif_uid && user.ticket_notif_uid !== user.uid) {
				this.sockets.subscribe(user.ticket_notif_uid, (data) => {
					self.notif_user(data, false);
				});
			}

			if (this.isAdmin)
			{
				this.sockets.subscribe("smartmydata", (data) => {
					self.notif_user(data, true);					
				});
			}

			this.notifications = await notifications_services.list_channels(["notification", window.location.host, user.client_uid])

			// Charger les notifications persistées sur le canal personnel (manquées hors connexion),
			// ainsi que sur le canal du compte principal du groupe (tickets) si différent.
			// IMPORTANT : `ticket_notifs` est persisté en localStorage (vuex-persistedstate).
			// Le serveur (Hermes) est la seule source de vérité : on repart d'une
			// cloche vide à chaque montage et on la reconstruit entièrement à
			// partir de ce qui est actuellement actif côté serveur, sinon les
			// entrées obsolètes (dismiss faits ailleurs, nettoyage dest legacy...)
			// restent bloquées indéfiniment dans le localStorage local.
			this.$store.commit('clearTicketNotifs');
			try {
				const notifChannels = [user.uid];
				if (user.ticket_notif_uid && user.ticket_notif_uid !== user.uid) notifChannels.push(user.ticket_notif_uid);
				console.log('[ticket-notif][front] fetching persisted notifs for channels=', notifChannels);
				const persistedNotifs = await notifications_services.list_channels(notifChannels);
				console.log('[ticket-notif][front] server returned', Array.isArray(persistedNotifs) ? persistedNotifs.length : persistedNotifs, 'notifications');
				if (Array.isArray(persistedNotifs)) {
					const ticketTypes = ['ticket_create', 'ticket_message', 'ticket_message_update', 'ticket_update', 'ticket_assign'];
					for (const n of persistedNotifs) {
						const d = typeof n.data === 'string' ? JSON.parse(n.data) : n.data;
						if (!d) continue;
						if (ticketTypes.includes(d.type)) {
							// Nettoyage : avant la bascule vers l'identité canonique, chaque
							// compte réel recevait sa propre notification (dest = son uid).
							// Ces vieilles copies orphelines (dest != uid canonique du groupe)
							// ne doivent plus jamais être affichées ni recomptées : on les
							// supprime silencieusement au lieu de les faire remonter dans la cloche.
							if (n.dest !== (user.ticket_notif_uid || user.uid)) {
								console.log('[ticket-notif][front] deleting stale/foreign-dest notif', n.uid, 'dest=', n.dest, 'expected=', (user.ticket_notif_uid || user.uid));
								notifications_services.delete(n.uid).catch(() => {});
								continue;
							}
							console.log('[ticket-notif][front] adding ticket notif for ticket', d.ticket_id, 'notif_uid=', n.uid);
							this.$store.commit('addOrBubbleTicketNotif', {
								ticket_id:    d.ticket_id,
								ticket_titre: d.ticket_titre || n.title || `Ticket #${d.ticket_id}`,
								type:         d.type,
								text:         d.text,
								time:         n.date || new Date().toISOString(),
								notif_uid:    n.uid
							});
						}
						else if (d.type !== 'message' && n.active)
						{
							n.data = d;
							this.personalNotifications.push(n);
						}
					}
				}
				console.log('[ticket-notif][front] final ticket_notifs count=', this.$store.getters.getTicketNotifs.length);
			} catch(e) { console.error('[ticket-notif][front] error loading persisted notifs', e); }

			var unseen_messages = await messages_services.getUnseenNb();

			//console.log("unseen_messages")
			//console.log(unseen_messages)

			this.$store.commit("setUnseenMessages", unseen_messages);

			if (user.env) this.env = client.details.env[user.env].name;
		},
	};
</script>

<style scoped>
.navbar-topbar {
	position: relative;
	z-index: 1000;
	flex-wrap: nowrap;
}
.navbar-env {
	max-width: 260px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.ticket-notif-item {
	padding: 9px 12px;
	border-bottom: 1px solid #f5f5f5;
	cursor: pointer;
	transition: background 0.15s;
}
.ticket-notif-item:hover {
	background-color: #fff8f0;
}
.ticket-notif-item:last-child {
	border-bottom: none;
}
</style>
